import PermissionChecker from 'src/modules/auth/permissionChecker';
import React from 'react';
import { Navigate, RouteProps } from 'react-router-dom';

interface EmptyTenantRouteProps extends Omit<RouteProps, 'element'> {
  component: React.ComponentType<any>;
  currentTenant: any;
  currentUser: any;
}

function EmptyTenantRoute({
  component: Component,
  currentTenant,
  currentUser,
  ..._rest
}: EmptyTenantRouteProps) {
  const permissionChecker = new PermissionChecker(
    currentTenant,
    currentUser,
  );

  if (!permissionChecker.isAuthenticated) {
    return (
      <Navigate
        to="/auth/signin"
        replace
      />
    );
  }

  if (!permissionChecker.isEmptyTenant) {
    return <Navigate to="/" replace />;
  }

  return <Component />;
}

export default EmptyTenantRoute;
